import * as React from 'react';
import { memo } from 'react';

const SvgZoomIn = (props) => (React.createElement("svg", Object.assign({ width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { clipRule: "evenodd", d: "M11 19a8 8 0 1 0 0-16 8 8 0 0 0 0 16Z", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("path", { d: "m21 21-4.35-4.35M11 8v6M8 11h6", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" })));
const Memo = memo(SvgZoomIn);

export { Memo as default };
